import {
    APP,
} from '_pixiSrc/globals';
import { MOBILE } from '_pixiSrc/layout/features';
import Sprite from '_pixiSrc/display/Sprite';
import GameConfig from '../libraries/GameConfig';
import DynamicData from '../ui/DynamicData';
import TextPanel from '../ui/TextPanel';
import GameData from '../ui/GameData';
import BigWin from '../ui/BigWin';
import AudioManager from '../ui/AudioManager';
import NetworkController from '../network/NetworkController';
import PayoutsPopup from '../ui/PayoutsPopup';
import OptionsLayout from '../ui/Options';
import Wheel from './Wheel';
import {
    GAME_DATA_KEY,
    GAME_PROPERTY_KEY,
} from '../Constants';

const lines = [];
let isAnimationAvaliable = false;
let globPar;
let globX;
let globY;
let hideLinesTimer = null;
const currentTweens = [];

/**
 * @class Line
 * Line class manage lines data and line animation
 */
class Line extends Sprite {
    /**
   * @name checkWin
   * @description counts the winning lines and launches animations
   */
    static checkWin() {
        const output = [];

        /**
     * get all paylines and view zone and
     * winning data
     */
        const winData = DynamicData.getData(GAME_DATA_KEY.WIN);
        const paylines = GameConfig.paylines;
        const viewZone = GameConfig.viewZone;

        /**
     * convert winning data into game code and return that data
     */
        for (const item of winData.winLines) {
            if (item.winLineId) {
                /**
         * get winning data from winning array
         */
                const current = paylines[item.winLineId];
                const tempOutput = {
                    line: current.paylineNumber,
                    lineLength: parseInt(item.winType.charAt(0)),
                    lineWinAmount: item.winAmount,
                    symbolNumber: NetworkController.convertSymbolsIdToNumber(item.symbolId),
                };
                const temp = [];
                for (let i = 0; i < current.keys.length; i++) {
                    const reel = [];
                    for (let j = 0; j < parseInt(viewZone.charAt(0)); j++) {
                        if (current[current.keys[i]] === j && i < tempOutput.lineLength) {
                            reel.push(1);
                        } else {
                            reel.push(0);
                        }
                    }
                    temp.push(reel);
                }
                tempOutput.result = temp;
                output.push(tempOutput);
            }
        }
        return output;
    }

    /**
   * @name addLines
   * @param parent
   * @param x
   * @param y
   * @description add paylines
   */
    static addLines(parent, x, y) {
        globX = x;
        globY = y;
        globPar = parent;
        const container = parent.addChild(new Sprite());
        container.position.set(x, y);

        window.blink = function () {
            lines.forEach(e => e.fadeTo(0, 500, null, () => {
                e.fadeTo(1, 500);
            }));
        };

        container.addChild(new Line(1, 0, -5));
        container.addChild(new Line(2, 0, -119));
        container.addChild(new Line(3, 0, 107));
        container.addChild(new Line(4, 0, -13));
        container.addChild(new Line(5, 0, 0));
        container.addChild(new Line(6, 0, 36));
        container.addChild(new Line(7, 0, -48));
        container.addChild(new Line(8, 0, -3));
        container.addChild(new Line(9, 0, -6));
        container.addChild(new Line(10, 0, -3));

        return container;
    }

    /**
   * @name showLines
   * @param inputArr
   * @param options
   * @description show winning payline animation
   */
    static showLines(inputArr, options = {}) {
        if (GameData.getProperty('isFreeGame')) { TextPanel.sendMessage('duringFG'); } else if (DynamicData.getData(GAME_DATA_KEY.SPECIALSPIN).freeSpins > 0) { TextPanel.sendMessage('duringSpecialSpin'); }

        options.lineAnimationCallback = options.lineAnimationCallback || function () { };

        lines.forEach(e => e.visible = true);
        isAnimationAvaliable = true;

        const lineNumbers = [];
        inputArr.forEach((e) => {
            lineNumbers.push(e.line);
        });

        const lineNumbersExp = [];
        if (options.resultExp) {
            options.resultExp.forEach((e) => {
                lineNumbersExp.push(e.line);
            });
        }

        let showCounter = 0;
        let currentLine = 0;

        /* We were doing all the checks on the fallen line and the generator form a sequence of calls */
        const linesAmount = lineNumbers.length;
        let isScatters = !!options.scatterAnimationCallback;
        const currentBet = DynamicData.getValue('totalBet');
        let isExpanded = false; // shows the expansion has already occurred or not, if it is free spin
        let isFirstCounterFinished = false;

        const isTurbo = GameData.getProperty(GAME_PROPERTY_KEY.TURBOCHECKED);
        // if (MOBILE && GameData.getProperty(GAME_PROPERTY_KEY.AUTOSPIN)) {
        //   isTurbo = GameData.getProperty(GAME_PROPERTY_KEY.AUTOTURBOCHECKED);
        // }

        /**
     * Generator with a sequence of calls of promises
     */
        function* showLinesSync() {
            if (showCounter === 0 && linesAmount > 0) { // first impression cycle
                AudioManager.muteMusic();
            }

            if (!isExpanded && DynamicData.getValue('lastWin')) {
                TextPanel.sendMessage('totalWin', DynamicData.getValue('lastWin'));
            }

            if (isTurbo) { // if TURBO MODE, then show all the lines at a time, if not, then one at a time
                if (isExpanded) {
                    TextPanel.sendMessage('expandingWin', DynamicData.getValue('lastExpandingWin'));
                }
                yield new Promise(allTogether);
            } else {
                const lenght = isExpanded ? options.resultExp.length : linesAmount;
                if (isExpanded) { // if expanding wins, then show all the lines at a time, if not, then one at a time
                    yield sleep(500);
                    yield new Promise(allTogether);
                } else {
                    do {
                        yield new Promise(oneByOne);
                        currentLine++;
                    } while (currentLine < lenght);
                }
            }

            if (showCounter === 0 && ((DynamicData.getValue('lastWin') - DynamicData.getValue('lastExpandingWin') > 0) || (DynamicData.getValue('lastWin') > 0 && DynamicData.getValue('lastExpandingWin') > 0))) {
                TextPanel.sendMessage('totalWin', DynamicData.getValue('lastWin'), () => isFirstCounterFinished = true);
            }

            if (showCounter === 0) {
                yield new Promise(openBigWinWindow.bind(this));
            }

            if (!isExpanded && isScatters && showCounter === 0) {
                yield new Promise(animateScatters);
                yield sleep(500);
                isScatters = false;
            }

            AudioManager.resumeMusic();

            if (!isScatters) {
                yield sleep(500);
                yield new Promise(expandSymbols);

                if (isExpanded && showCounter === 0) {
                    TextPanel.sendMessage('expandingWin', DynamicData.getValue('lastExpandingWin'));
                }

                if (showCounter === 1) {
                    yield new Promise(openBigWinWindowExp.bind(this));
                }

                if (GameData.getProperty('isAutospin') && !isScatters && options.callback) {
                    if (isExpanded && showCounter === 0) { return; } // if the exandings are revealed, then we must wait until the next cycle shows all the lines

                    options.callback(linesAmount > 0);
                    options.callback = null;
                    isAnimationAvaliable = false;
                }
            }
        }

        /* unskilled labor function */
        function execute(generator, yieldValue) {
            if (!isAnimationAvaliable) { return; } // if the next spin begins, then we do not continue
            if (GameData.getProperty('isGambleActive')) { return; } // if user gamble and lose, the next line does not show
            if (GameData.getProperty('isPopupDialogueOpen', false)) { return; } // if the dialog box with the button is open, then we also interrupt the cycle
            if (GameData.getProperty('isPPOpen')) { // if the payout window is open (the player clicked on the symbol on the field), then the sequence is paused and resumed only after the window is closed
                PayoutsPopup.callback = () => execute(generator, yieldValue);
                return;
            }

            if (OptionsLayout.isOpen) {
                OptionsLayout.passCloseCallback(() => { execute(generator, yieldValue); });
                return;
            }

            const next = generator.next(yieldValue);

            if (!next.done) {
                next.value.then(
                    result => execute(generator, result),
                    err => generator.throw(err),
                );
            } else {
                showCounter++;
                currentLine = 0;

                if (options.callback && (!isExpanded || (isExpanded && showCounter > 1))) {
                    options.callback();
                    return;
                }

                if ((isExpanded) && !isScatters) { execute(showLinesSync.call(this)); }
            }
        }

        execute(showLinesSync.call(this));

        /* lines animation functions */

        function waitForCounter(res) {
            if (isFirstCounterFinished) { res(); } else { setTimeout(() => waitForCounter(res), 100); }
        }

        function expandSymbols(res) {
            if (GameData.getProperty('isFreeGame') && GameData.getProperty('expandingSymbol') !== false && options.resultExp && options.resultExp.length && !isExpanded) {
                isExpanded = true;
                NetworkController.getExpandingSymbolResult(GameData.getProperty('expandingSymbol'), Wheel.lastResult, Wheel.expandSymbols.bind(null, res));
            } else {
                res();
            }
        }

        let expandingSoundPlay = false;
        let expandingAllSoundPlay = false;

        function getAllSymbols() {
            const lineArr = [
                [0, 0, 0],
                [0, 0, 0],
                [0, 0, 0],
                [0, 0, 0],
                [0, 0, 0],
            ];

            const array = isExpanded ? options.resultExp : inputArr;

            if (!array.length) {
                return lineArr;
            }

            array.forEach((obj) => {
                obj.result.forEach((wheel, wheelInd) => {
                    wheel.forEach((e, eInd) => {
                        if (e === 1) { lineArr[wheelInd][eInd] = 1; }
                    });
                });
            });

            return lineArr;
        }

        function allTogether(res) {
            let linesAnimated = 0;

            const array = isExpanded ? options.resultExp : inputArr;
            const lineN = isExpanded ? lineNumbersExp : lineNumbers;

            if (!array.length) {
                res();
                return;
            }

            const lineArr = getAllSymbols();

            let fiveSymbols = false;

            for (let y = 0; y < 3; y++) {
                let cnt = 0;
                for (let x = 0; x < 5; x++) {
                    if (lineArr[x][y] == 1) { cnt++; }
                }
                if (cnt == 5) { fiveSymbols = true; }
            }

            if (showCounter === 0 && !isExpanded) {
                let maxSymbol = 0;

                if (fiveSymbols) {
                    maxSymbol = 100;
                } else {
                    array.forEach((obj) => {
                        if (obj.symbolNumber > maxSymbol) {
                            maxSymbol = obj.symbolNumber;
                        }
                    });
                }

                playSingleSymbolSound(maxSymbol);
            }

            options.lineAnimationCallback(lineArr); // run character animation

            if (showCounter === 1 && isExpanded && !expandingAllSoundPlay) {
                AudioManager.playSound('fx', 'win_lines_all');
                expandingAllSoundPlay = true;
            }

            lineN.forEach((e) => {
                currentTweens.push(lines[e].addTween('alpha', 1, GameConfig.allLinesAnimationDuration / 2, null, () => {
                    currentTweens.push(lines[e].addTween('alpha', 0, GameConfig.allLinesAnimationDuration / 2, null, () => {
                        if (++linesAnimated == lineN.length) {
                            res('done');
                        }
                    }).play());
                }).play());
            });
        }

        function playSingleSymbolSound(s) {
            switch (s) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    AudioManager.playSound('fx', 'win_lines');
                    break;
                case 5:
                    AudioManager.playSound('fx', 'high2_symbols_in_line');
                    break;
                case 6:
                    AudioManager.playSound('fx', 'high1_symbols_in_line');
                    break;
                case 7:
                    AudioManager.playSound('fx', 'high4_symbols_in_line');
                    break;
                case 8:
                    AudioManager.playSound('fx', 'high3_symbols_in_line');
                    break;
                case 100:
                    AudioManager.playSound('fx', '5_of_a_kind');
                    break;
            }
        }

        function oneByOne(res, rej, elementNumber = currentLine) {
            const lineArr = [];

            let array = isExpanded ? options.resultExp : inputArr;

            const lineN = isExpanded ? lineNumbersExp : lineNumbers;

            if (!array.length) {
                res();
                return;
            }

            let symbolNumber;

            let lineLength = 0;
            let lineNumber = 0;
            let winAmount = 0;

            array.forEach((obj) => {
                if (obj.line === lineN[elementNumber]) {
                    lineLength = obj.lineLength;
                    lineNumber = obj.line;
                    array = obj.result.slice();
                    symbolNumber = obj.symbolNumber;
                    winAmount = obj.lineWinAmount;
                }
            });

            // TextPanel.sendMessage('lineWin', winAmount, (lineNumber + 1));


            if (lineLength >= 5) { symbolNumber = 100; }

            playSymbolSound(symbolNumber);

            function playSymbolSound(s) {
                if (isExpanded && showCounter === 1 && !expandingSoundPlay) {
                    AudioManager.playSound('fx', 'win_lines_expanding');
                    expandingSoundPlay = true;
                }

                if (!isExpanded && showCounter === 0) {
                    playSingleSymbolSound(s);
                }
            }

            if (isExpanded) {
                Wheel.startAnimateSymbols(getAllSymbols());
            }

            options.lineAnimationCallback(array, isExpanded ? 2 : 1); // run character animation

            const delimiter = isExpanded ? 8 : 2;

            currentTweens.push(lines[lineN[elementNumber]].addTween('alpha', 1, GameConfig.singleLineAnimationDuration / delimiter, null, () => {
                if (isExpanded) { res(`done line number ${elementNumber}`); }
                currentTweens.push(lines[lineN[elementNumber]].addTween('alpha', 0, GameConfig.singleLineAnimationDuration / delimiter, null, () => {
                    if (!isExpanded) { res(`done line number ${elementNumber}`); }
                }).play());
            }).play());
        }

        function animateScatters(res) {
            Wheel.refreshView();
            AudioManager.playSound('fx', 'scatter_symbols_together');
            options.scatterAnimationCallback(res);
            TextPanel.sendMessage('triggerFG');
        }

        function openBigWinWindow(res) {
            BigWin.invoke(globPar.parent.parent, 0, 0, res, false, currentBet);
        }

        function openBigWinWindowExp(res) {
            BigWin.invoke(globPar.parent.parent, 0, 0, res, true, currentBet);
        }

        function sleep(time) {
            if (sleep.sleepCounter === undefined) { sleep.sleepCounter = 0; } // The first call to the function is returned without a timeout
            return sleep.sleepCounter++ === 0 ? new Promise(res => res()) : new Promise(res => setTimeout(res, time));
        }
    }

    /**
   * @name hideLines
   * @description hide all line animation
   */
    static hideLines() {
        clearTimeout(hideLinesTimer);
        currentTweens.forEach(e => e.stop());
        lines.forEach(e => e.fadeTo(0));
        lines.forEach(e => e.visible = false);
        isAnimationAvaliable = false;
        AudioManager.resumeMusic(100);
    }

    /**
   * @name showCurrentLines
   * @param amount
   * @description show all selected payline
   */
    static showCurrentLines(amount) {
        lines.forEach(e => e.alpha = 0);

        for (let i = 0; i < amount; i++) {
            lines[i].alpha = 1;
        }

        if (hideLinesTimer) { clearTimeout(hideLinesTimer); }

        hideLinesTimer = setTimeout(() => {
            for (let i = 0; i < amount; i++) {
                if (lines[i].alpha) { lines[i].fadeTo(0, 500); }
            }
        }, 5000);
    }

    constructor(lineNumber, x, y) {
        super();

        this.position.set(x, y);

        this.line = this.addChild(APP.library.getSprite(`game/lines/${lineNumber}`));
        this.line.fadeTo(0);

        lines.push(this.line);

        this.addLabels(lineNumber);
    }

    /**
   * @name addLabels
   * @param lineNumber
   * @description add line label to payline
   */
    addLabels(lineNumber) {
        const leftDiamond = this.line.addChild(APP.library.getSprite('game/lines/diamond_glow'));
        leftDiamond.x = -388;

        const rightDiamond = this.line.addChild(APP.library.getSprite('game/lines/diamond_glow'));
        rightDiamond.x = 384;

        const left = this.line.addChild(APP.library.getSprite(`game/lines/win_${lineNumber}_L`));
        left.x = -390;
        left.interactive = true;
        left.buttonMode = true;
        left.cursor = 'pointer';

        const right = this.line.addChild(APP.library.getSprite(`game/lines/win_${lineNumber}_R`));
        right.x = 389;
        right.interactive = true;
        right.buttonMode = true;
        right.cursor = 'pointer';

        switch (lineNumber) {
            case 1:
                leftDiamond.y = 1;
                rightDiamond.y = 1;
                left.y = 1;
                right.y = 1;
                break;
            case 2:
                leftDiamond.y = -2;
                rightDiamond.y = -2;
                left.y = 15;
                right.y = 12;
                break;
            case 3:
                leftDiamond.y = 8;
                rightDiamond.y = 8;
                left.y = -10;
                right.y = -10;
                break;
            case 4:
                leftDiamond.y = -108;
                rightDiamond.y = -108;
                left.y = -130;
                right.y = -127;
                break;
            case 5:
                leftDiamond.y = 116;
                rightDiamond.y = 116;
                left.y = 132;
                right.y = 132;
                break;
            case 6:
                leftDiamond.y = -38;
                rightDiamond.y = -38;
                left.y = -78;
                right.y = -78;
                break;
            case 7:
                leftDiamond.y = 46;
                rightDiamond.y = 46;
                left.y = 78;
                right.y = 78;
                break;
            case 8:
                leftDiamond.y = 118;
                rightDiamond.y = -118;
                left.y = 65;
                right.y = -70;
                break;
            case 9:
                leftDiamond.y = -116;
                rightDiamond.y = 120;
                left.y = -68;
                right.y = 68;
                break;
            case 10:
                leftDiamond.y = 118;
                rightDiamond.y = -118;
                left.y = 170;
                right.y = -165;
                break;
        }

        left.on('mouseover', () => {
            this.line.fadeTo(1, 200);
        });
        left.on('mouseout', () => {
            this.line.fadeTo(0, 200);
        });

        right.on('mouseover', () => {
            this.line.fadeTo(1, 200);
        });
        right.on('mouseout', () => {
            this.line.fadeTo(0, 200);
        });
    }
}

export default Line;
